export const AUTH_LOGIN = 'auth/login';
export const AUTH_REGISTER = 'auth/register';
export const AUTH_ACCEPT_INVITE = 'auth/accept-invite';
export const AUTH_REFRESH = 'auth/refresh';
export const ORGANISATIONS_ME_ENDPOINT = 'organisations/me';
export const ORGANISATIONS_ME_INVITE_ENDPOINT = 'organisations/me/invite';
export const ORGANISATIONS_ME_USERS_ENDPOINT = 'organisations/me/users';
export const AUDIT_ENDPOINT = 'audit';
export const CONTENT_ENDPOINT = 'content/upload';
export const DOCTYPES_ENDPOINT = 'doctypes';
export const FACETS_ENDPOINT = 'facets';
export const PACKAGE_ENTITIES_ENDPOINT = 'package/fetch';
export const PACKAGE_ENDPOINT = 'package';
export const PERMISSIONS_ENDPOINT = 'permissions';
export const USERS_AND_GROUPS_ENDPOINT = 'users-groups';
export const SCHEMAS_ENDPOINT = 'schemas';
export const LIFECYCLES_ENDPOINT = 'lifecycles';
export const STRUCTURE_TEMPLATES_ENDPOINT = 'structure-templates';
export const BUILD_PACKAGE_ENDPOINT = 'package/build';
export const AUTOMATION_SCRIPTING = 'automation/scripts';
export const AUTOMATION_CHAINS = 'automation/chains';
export const AUTOMATION_EVENT_HANDLERS = 'automation/events';
export const APPLICATION_INFORMATION_ENDPOINT = 'application-information';
export const APPLICATION_DEFINITION_ENDPOINT = 'application-definition';
export const GIT_BRANCHES_ENDPOINT = 'git/branch';
export const GIT_BRANCH_COMMITS_ENDPOINT = 'git/branch/commits';
export const TEMPLATES = 'templates';
export const VOCABULARIES_ENDPOINT = 'vocabularies';
export const WORKFLOWS_ENDPOINT = 'workflows';
export const DOCTYPE_LAYOUT_ENDPOINT = 'doctype-layout';
export const SEARCH_MAPPING_ENDPOINT = 'search-mapping';
export const PAGE_PROVIDERS_ENDPOINT = 'page-provider';
export const PAGE_PROVIDERS_LAYOUT_ENDPOINT = 'page-provider-layout';
export const WORKFLOW_LAYOUT_ENDPOINT = 'workflow-layout';
export const DASHBOARD_ENDPOINT = 'dashboards';
export const UPLOAD_FILES = 'content/upload';
export const XML_EXTENSIONS = 'xml-extensions';
export const TRANSLATIONS = 'translations';
export const BUTTONS_ENDPOINT = 'buttons';
export const TABS_ENDPOINT = 'tabs';
export const DRAWERS_ENDPOINT = 'drawers';
export const DRAWER_ITEMS_ENDPOINT = 'drawer-items';
export const DRAWER_PAGES_ENDPOINT = 'drawer-pages';
export const DRAWER_PAIRS_ENDPOINT = 'drawer-pairs';
export const BRANDING_ENDPOINT = 'branding';
export const THEMES_ENDPOINT = 'themes';
export const BUNDLE_ENDPOINT = 'bundle';
export const ELEMENT_ENDPOINT = 'elements';
export const UI_RESOURCES_ENDPOINT = 'ui-resources';
export const IMPORT_PACKAGE = 'package/import';
